<template>
  <div>
    <div class="card modal-background">
    <div class="card-content">
      <p class="title is-4">{{ $t(`${translationPath}.title`) }}</p>
      <p>{{ text }}</p>

      <div class="content" style="margin-top: 20px;">
          <b-field v-if="type === 'NFC'">
              <b-input maxlength="200" :value="webhook"
              type="textarea"></b-input>
          </b-field>
          <b-field>
              <b-button type="is-secondary"
                expanded @click="generateQRCode">
                {{ $t(`${translationPath}.downloadQRCode`) }}</b-button>
          </b-field>
          <b-field>
              <b-checkbox @input="resetPassword"
              :disabled="removePassword" size="is-medium" v-model="withPassword" >
                {{ $t(`${translationPath}.addNewPassword`) }}</b-checkbox>
          </b-field>
          <b-field>
              <b-checkbox :disabled="withPassword"
                size="is-medium" v-model="removePassword">
                {{ $t(`${translationPath}.removePassword`) }}</b-checkbox>
          </b-field>
          <b-field :label="$t(`${translationPath}.password`)" v-if="withPassword">
              <b-input v-model="password"></b-input>
          </b-field>
          <b-field>
              <b-button type="is-primary"
                expanded @click="closeEvent">
                {{ (password || removePassword === true)
                  ? $t(`${translationPath}.save`) : $t(`${translationPath}.exit`) }}
              </b-button>
          </b-field>
          <b-field v-if="!isIos">
              <b-button type="is-secondary"
                expanded @click="writeTag">{{ $t(`${translationPath}.saveToNFCTag`) }}</b-button>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setToFirebase } from '../../../mixins/firebase';

export default {
  props: {
    webhook: String,
    globalId: String,
    type: String,
    generateQRCode: Function,
    text: String,
    isIos: Boolean,
  },
  data() {
    return {
      withPassword: false,
      password: '',
      removePassword: false,
      translationPath: 'itemModal',
    };
  },
  methods: {
    resetPassword() {
      this.password = '';
    },
    closeEvent() {
      if (this.withPassword) {
        setToFirebase(`habits/${this.globalId}/password`, this.password, true);
      }
      if (this.removePassword) {
        setToFirebase(`habits/${this.globalId}/password`, '', true);
      }
      if (!this.password && this.removePassword === false) return this.$emit('close');
      this.removePassword = false;
      this.withPassword = false;
      this.password = '';

      return 'notification';
    },
    async writeTag() {
      if ('NDEFReader' in window) {
        const item = this.$buefy.snackbar.open({
          message: this.$t(`${this.translationPath}.writeToNFCTagMessage`),
          indefinite: true,
        });
        // eslint-disable-next-line no-undef
        const ndef = new NDEFReader();
        try {
          await ndef.write(
            {
              records: [
                {
                  recordType: 'url',
                  data: this.webhook,
                }],
            },
          );
          this.$buefy.toast.open({
            message: this.$t(`${this.translationPath}.saveNFCSucces`),
            type: 'is-success',
          });
          item.close();
        } catch (error) {
          alert(error);
          item.close();
        }
      } else {
        alert(this.$t(`${this.translationPath}.yourPhoneDontSupportNFC`));
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .modal-background {
    min-height: 100vh;
    height: 100%;
    background: $background-light-color;
    border-radius: 0;
  }
</style>
